import { toTitleCase } from "./string";

const apiErrorHandler = (response) => {
  if (!response) {
    return "Unknown error!";
  }
  if (response?.error) {
    return response.error;
  }

  if (response.status === 500) {
    return "Server error!";
  }

  if (response.status === 404) {
    return "Page not found!";
  }

  if (response.status === 401) {
    return "Authentication error!";
  }

  if (response.status === 403) {
    return "Permission denied!";
  }

  if (typeof response === "string") {
    const search = response.search("IntegrityError");
    if (search != -1) {
      return "Zaten sistemde böyle bir kayıt var.";
    }
    return response.slice(0, 100);
  }

  if (typeof response === "object") {
    if (response?.detail) {
      return response.detail;
    }

    const errors = {};
    Object.entries(response).forEach(([key, value]) => {
      errors[key] = Array.isArray(value) ? value.join(",") : value;
    });

    return Object.entries(errors)
      .map(([key, value]) => `${toTitleCase(key)}: ${value}`)
      .toString();
  }

  return "";
};

export { apiErrorHandler };
